export abstract class EnvironmentUtils {
    static isLocalhost() {
        return window.location.href.includes('http://localhost');
    }
}
